export default __webpack_public_path__ + "static/media/Illustration.69bfb40d.svg";